import Sortable from 'sortablejs';

const checkboxNodes = document.querySelectorAll( '.realpress-checkbox-content-wrapper.realpress-sortable' );

const realpressCheckboxSortable = () => {
	if ( ! checkboxNodes ) {
		return;
	}
	for ( let i = 0; i < checkboxNodes.length; i++ ) {
		const checkboxNode = checkboxNodes[ i ];
		Sortable.create( checkboxNode, {
			handle: '.realpress-checkbox-content span', animation: 150,
			onEnd() {
				reindexCheckbox( checkboxNode );
			},
		} );
	}
};

const reindexCheckbox = ( checkboxNode ) => {
	let value = '';
	checkboxNode.querySelectorAll( '.realpress-checkbox-content' ).forEach( function( checkboxContentNode ) {
		checkboxContentNode.querySelectorAll( 'input[type="checkbox"]' ).forEach( function( inputNode ) {
			value += inputNode.value + ',';
		} );
	} );
	value = value.slice( 0, -1 );

	checkboxNode.querySelector( ':scope > input[type=hidden]' ).value = value;
};

export default realpressCheckboxSortable;
